exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.maxWidth850[data-v-e6c932f8] {\n  max-width: 850px;\n}\n", ""]);
